interface UseDynamicMaskParams {
  lengthVariants: number[];
  maskPattern?: RegExp;
  placeholderChar?: string;
  value?: string;
}

type DynamicMaskResult = {
  maskitoMask: RegExp | RegExp[];
  placeholder: string;
  regexpPattern: string;
  currentLength: number;
};

const OPEN_LENGTH_DIGITS_MASK = /^\d*$/;

export const useDynamicMask = ({
  lengthVariants,
  maskPattern = /\d/,
  placeholderChar = '0',
  value,
}: UseDynamicMaskParams): DynamicMaskResult => {
  if (!lengthVariants.length) {
    return {
      maskitoMask: OPEN_LENGTH_DIGITS_MASK,
      placeholder: '',
      regexpPattern: '^\\d+$',
      currentLength: 0,
    };
  }

  const currentLength =
    lengthVariants.find((length) => length >= (value?.length ?? 0)) ?? 0;
  const hasNextLength = currentLength < (lengthVariants.at(-1) ?? 0);

  const maskLength = currentLength + (hasNextLength ? 1 : 0);
  const maskitoMask: RegExp[] = Array(maskLength).fill(maskPattern);
  const placeholder = placeholderChar.repeat(currentLength);
  const regexpPattern = lengthVariants
    .map((length) => `^\\d{${length}}$`)
    .join('|');

  return {
    maskitoMask,
    placeholder,
    regexpPattern,
    currentLength,
  };
};
